




























































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import { deviceServer, dictServe, doublePrevention, professionServer, regionServe, tagServer } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component({
  components: { PagingUnit },
  mixins: [TableStripe],
  filters: {
    ChangeType(type: string) {
      switch (type) {
        case 'add':
          return '新增';
        case 'edit':
          return '编辑';
        case 'detail':
          return '详情';
      }
    },
  },
})
export default class PublicPage extends Vue {
  @Prop(Object) rowData: any;
  private formData: any = {
    riskPointId: '',
    dangerSourceId: '',
    riskTypeTagName: '',
    energyCharacteristic: '',
    controlHierarchy: '',
    riskDescription: '',
    hurtDegree: '',
    taskRiskPoint: '',
    possibility: '',
    seriousness: '',
    riskDegree: '',
    riskLevel: '低风险',
    deviceId: '',
    postId: '',
    measuresForTrainingEducation: '',
    emergencyMeasures: '',
    remark: '',
    riskEventDescription: '',
    consequenceDescription: '',
    riskPointType: '',
    companyPlaceType: '',
    companyId: '',
  };
  formRules: any = {
    riskPointId: [{ required: true, message: '请选择风险点', trigger: 'change' }],
    riskDescription: [{ required: true, message: '请输入风险描述', trigger: 'blur' }],
    riskEventDescription: [{ required: true, message: '请输入风险事件名称', trigger: 'blur' }],
    consequenceDescription: [{ required: true, message: '请输入后果描述', trigger: 'blur' }],
    riskLevel: [{ required: true, message: '请选择风险等级', trigger: 'change' }],
  };

  private areaId = ''; // 区域 id
  private areaList: any = []; // 所在区域
  private riskPointAndDangerData: any = [];
  private riskPointList: any = [];
  private dangerSourceIdList: any = [];
  private controlHierarchyList: any = [];

  private riskDescriptionList: any = [];
  private hazardLevelOptions: any = [];
  private hazardCategoryTagNameList: any = [];
  private hazardCategoryTagNameOptions: any = [];
  private postIdList: any = [];
  private deviceList: any = [];

  private isDetail: any = false;

  private technologyMeasureHazardList: any = [];
  private controlMeasuresHazardList: any = [];
  private individualProtectShowHazardList: any = [];
  private trainingAndEducationalMeasuresHazardList: any = [];
  private emergencyTreatmentMeasuresHazardList: any = [];

  private submitLoading: any = false;

  levelRisk() {
    if (this.formData.possibility && this.formData.seriousness) {
      const levelNum: any = this.formData.possibility * this.formData.seriousness;
      if (levelNum <= 8) {
        this.formData.riskLevel = '低风险';
      } else if (levelNum <= 12) {
        this.formData.riskLevel = '一般风险';
      } else if (levelNum <= 16) {
        this.formData.riskLevel = '较大风险';
      } else {
        this.formData.riskLevel = '重大风险';
      }
    } else {
      this.formData.riskLevel = '低风险';
    }
  }

  created() {
    this.getAllDeviceListData();
    this.getAreaListData();
    this.getAllPostListData();
    this.getDetailsMapByNameData('controlHierarchy');
    if (this.rowData.type === 'add') {
      this.getHazardCategoryTagNameList();
      this.getDetailsMapByNameData('securityCheckHazardLevel');
      this.isDetail = false;
    } else {
      this.isDetail = this.rowData.type === 'detail';
      this.getRiskControlInventoryDetail();
    }
  }
  private getAreaListData() {
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    regionServe
      .getAreaAndSubAreaList({ areaId: userInfo.areaId })
      .then((res: any) => {
        if (res.code === '200') {
          this.areaList = arrayToTree(res.data);
          this.areaId = userInfo.areaId;
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败！');
      });
  }
  private areaChange(e: any) {
    this.formData.riskPointId = '';
    this.formData.dangerSourceId = '';
    doublePrevention
      .getRiskAll({ areaId: e })
      .then((res: any) => {
        if (res.code === '200') {
          this.riskPointAndDangerData = res.data;
          this.riskPointList = res.data.filter((item: any) => item.type === '风险点');
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败！');
      });
  }
  private riskPointChange(e: any) {
    this.formData.dangerSourceId = '';
    const findData: any = this.riskPointList.find((item: any) => item.id === e);
    this.formData.riskPointType = findData.riskPointType;
    this.formData.companyPlaceType = findData.companyPlaceType;
    this.formData.companyId = findData.companyId;
    this.dangerSourceIdList = this.riskPointAndDangerData.filter((item: any) => item.type === '危险源' && item.pid === e);
    if (this.rowData.type === 'edit') {
      this.technologyMeasureHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.controlMeasuresHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.individualProtectShowHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.trainingAndEducationalMeasuresHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.emergencyTreatmentMeasuresHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.getRiskDescriptionListData({ riskPointId: e });
    }
  }
  private dangerSourceChange(e: any) {
    if (this.rowData.type === 'edit') {
      this.technologyMeasureHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.controlMeasuresHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.individualProtectShowHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.trainingAndEducationalMeasuresHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.emergencyTreatmentMeasuresHazardList.forEach((item: any) => {
        for (const key in item) {
          item[key] = '';
        }
      });
      this.getRiskDescriptionListData({
        riskPointId: this.formData.riskPointId,
        dangerSourceId: e,
      });
    }
  }
  // 数据字典 -> 获取管控层级列表
  private getDetailsMapByNameData(name: any) {
    dictServe.getDetailsMapByName(name).then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        if (name === 'controlHierarchy') {
          this.controlHierarchyList = helpArr;
        } else {
          this.hazardLevelOptions = helpArr;
        }
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  private getRiskDescriptionListData(opts: any) {
    doublePrevention.getRiskControlInventoryHazardAll(opts).then((res: any) => {
      if (res.code === '200') {
        this.riskDescriptionList = res.data;
      }
    });
  }
  private getHazardCategoryTagNameList() {
    tagServer
      .getAllList({ type: 'hazardClassify' })
      .then((res: any) => {
        res.data.forEach((r: any) => {
          if (!r.children.length) {
            delete r.children;
          }
        });
        this.hazardCategoryTagNameList = res.data;
        this.hazardCategoryTagNameOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  private getAllPostListData() {
    professionServer
      .getPageDataAll({})
      .then((res: any) => {
        this.postIdList = res.data;
      })
      .catch((error: any) => {
        this.$message.warning('获取岗位的数据失败！');
      });
  }
  private getAllDeviceListData() {
    deviceServer
      .getDeviceInfoAllData({})
      .then((res: any) => {
        this.deviceList = res.data;
      })
      .catch((error: any) => {
        this.$message.warning('获取岗位的数据失败！');
      });
  }

  /**
   * 工程管控措施 操作
   * */
  addByMeasureTypeRowData(type: any) {
    if (type === '1') {
      if (!this.technologyMeasureHazardList.length) {
        this.technologyMeasureHazardList.push({
          riskDescription: '',
          hazardControlMeasure: '',
          riskControlRunawayShow: '',
          hazardCategoryTagId: '',
          hazardCategoryTagName: '',
          hazardCode: '',
          riskLevel: '',
          postIds: [],
          taskPostId: '',
          teamGroup: '',
          stockRoom: '',
          workShop: '',
          company: '',
          id: '',
        });
      } else {
        const lastRowData: any = this.technologyMeasureHazardList[this.technologyMeasureHazardList.length - 1];
        if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
          this.$message.warning('请先将该行数据填写完整！');
        } else {
          this.technologyMeasureHazardList.push({
            riskDescription: '',
            hazardControlMeasure: '',
            riskControlRunawayShow: '',
            hazardCategoryTagId: '',
            hazardCategoryTagName: '',
            hazardCode: '',
            riskLevel: '',
            postIds: [],
            taskPostId: '',
            teamGroup: '',
            stockRoom: '',
            workShop: '',
            company: '',
            id: '',
          });
        }
      }
    }
    if (type === '2') {
      if (!this.controlMeasuresHazardList.length) {
        this.controlMeasuresHazardList.push({
          riskDescription: '',
          hazardControlMeasure: '',
          riskControlRunawayShow: '',
          hazardCategoryTagId: '',
          hazardCategoryTagName: '',
          hazardCode: '',
          riskLevel: '',
          postIds: [],
          taskPostId: '',
          teamGroup: '',
          stockRoom: '',
          workShop: '',
          company: '',
          id: '',
        });
      } else {
        const lastRowData: any = this.controlMeasuresHazardList[this.controlMeasuresHazardList.length - 1];
        if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
          this.$message.warning('请先将该行数据填写完整！');
        } else {
          this.controlMeasuresHazardList.push({
            riskDescription: '',
            hazardControlMeasure: '',
            riskControlRunawayShow: '',
            hazardCategoryTagId: '',
            hazardCategoryTagName: '',
            hazardCode: '',
            riskLevel: '',
            postIds: [],
            taskPostId: '',
            teamGroup: '',
            stockRoom: '',
            workShop: '',
            company: '',
            id: '',
          });
        }
      }
    }
    if (type === '3') {
      if (!this.individualProtectShowHazardList.length) {
        this.individualProtectShowHazardList.push({
          riskDescription: '',
          hazardControlMeasure: '',
          riskControlRunawayShow: '',
          hazardCategoryTagId: '',
          hazardCategoryTagName: '',
          hazardCode: '',
          riskLevel: '',
          postIds: [],
          taskPostId: '',
          teamGroup: '',
          stockRoom: '',
          workShop: '',
          company: '',
          id: '',
        });
      } else {
        const lastRowData: any = this.individualProtectShowHazardList[this.individualProtectShowHazardList.length - 1];
        if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
          this.$message.warning('请先将该行数据填写完整！');
        } else {
          this.individualProtectShowHazardList.push({
            riskDescription: '',
            hazardControlMeasure: '',
            riskControlRunawayShow: '',
            hazardCategoryTagId: '',
            hazardCategoryTagName: '',
            hazardCode: '',
            riskLevel: '',
            postIds: [],
            taskPostId: '',
            teamGroup: '',
            stockRoom: '',
            workShop: '',
            company: '',
            id: '',
          });
        }
      }
    }
    if (type === '4') {
      if (!this.trainingAndEducationalMeasuresHazardList.length) {
        this.trainingAndEducationalMeasuresHazardList.push({
          riskDescription: '',
          hazardControlMeasure: '',
          riskControlRunawayShow: '',
          hazardCategoryTagId: '',
          hazardCategoryTagName: '',
          hazardCode: '',
          riskLevel: '',
          postIds: [],
          taskPostId: '',
          teamGroup: '',
          stockRoom: '',
          workShop: '',
          company: '',
          id: '',
        });
      } else {
        const lastRowData: any = this.trainingAndEducationalMeasuresHazardList[this.trainingAndEducationalMeasuresHazardList.length - 1];
        if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
          this.$message.warning('请先将该行数据填写完整！');
        } else {
          this.trainingAndEducationalMeasuresHazardList.push({
            riskDescription: '',
            hazardControlMeasure: '',
            riskControlRunawayShow: '',
            hazardCategoryTagId: '',
            hazardCategoryTagName: '',
            hazardCode: '',
            riskLevel: '',
            postIds: [],
            taskPostId: '',
            teamGroup: '',
            stockRoom: '',
            workShop: '',
            company: '',
            id: '',
          });
        }
      }
    }
    if (type === '5') {
      if (!this.emergencyTreatmentMeasuresHazardList.length) {
        this.emergencyTreatmentMeasuresHazardList.push({
          riskDescription: '',
          hazardControlMeasure: '',
          riskControlRunawayShow: '',
          hazardCategoryTagId: '',
          hazardCategoryTagName: '',
          hazardCode: '',
          riskLevel: '',
          postIds: [],
          taskPostId: '',
          teamGroup: '',
          stockRoom: '',
          workShop: '',
          company: '',
          id: '',
        });
      } else {
        const lastRowData: any = this.emergencyTreatmentMeasuresHazardList[this.emergencyTreatmentMeasuresHazardList.length - 1];
        if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
          this.$message.warning('请先将该行数据填写完整！');
        } else {
          this.emergencyTreatmentMeasuresHazardList.push({
            riskDescription: '',
            hazardControlMeasure: '',
            riskControlRunawayShow: '',
            hazardCategoryTagId: '',
            hazardCategoryTagName: '',
            hazardCode: '',
            riskLevel: '',
            postIds: [],
            taskPostId: '',
            teamGroup: '',
            stockRoom: '',
            workShop: '',
            company: '',
            id: '',
          });
        }
      }
    }
  }
  delRowTechnologyMeasureData(type: any, rowIndex: any) {
    if (type === '1') {
      this.technologyMeasureHazardList.splice(rowIndex, 1);
    }
    if (type === '2') {
      this.controlMeasuresHazardList.splice(rowIndex, 1);
    }
    if (type === '3') {
      this.individualProtectShowHazardList.splice(rowIndex, 1);
    }
    if (type === '4') {
      this.trainingAndEducationalMeasuresHazardList.splice(rowIndex, 1);
    }
    if (type === '5') {
      this.emergencyTreatmentMeasuresHazardList.splice(rowIndex, 1);
    }
  }
  hazardCategoryTypeChange1(data: any, e: any) {
    data.hazardCategoryTagName = '';
    if (e) {
      data.hazardCategoryTagName = (this.$refs.elCascaderHazardType1 as any).getCheckedNodes()[0].label;
    } else {
      data.hazardCategoryTagName = '';
    }
  }
  hazardCategoryTypeChange2(data: any, e: any) {
    data.hazardCategoryTagName = '';
    if (e) {
      data.hazardCategoryTagName = (this.$refs.elCascaderHazardType2 as any).getCheckedNodes()[0].label;
    } else {
      data.hazardCategoryTagName = '';
    }
  }
  hazardCategoryTypeChange3(data: any, e: any) {
    data.hazardCategoryTagName = '';
    if (e) {
      data.hazardCategoryTagName = (this.$refs.elCascaderHazardType3 as any).getCheckedNodes()[0].label;
    } else {
      data.hazardCategoryTagName = '';
    }
  }
  hazardCategoryTypeChange4(data: any, e: any) {
    data.hazardCategoryTagName = '';
    if (e) {
      data.hazardCategoryTagName = (this.$refs.elCascaderHazardType4 as any).getCheckedNodes()[0].label;
    } else {
      data.hazardCategoryTagName = '';
    }
  }
  hazardCategoryTypeChange5(data: any, e: any) {
    data.hazardCategoryTagName = '';
    if (e) {
      data.hazardCategoryTagName = (this.$refs.elCascaderHazardType5 as any).getCheckedNodes()[0].label;
    } else {
      data.hazardCategoryTagName = '';
    }
  }
  rowRiskDescription(data: any) {
    const findRow: any = this.riskDescriptionList.find((item: any) => item.id === data.id);
    data.riskDescription = findRow.riskDescription;
    data.hazardControlMeasure = findRow.hazardControlMeasure;
    data.hazardCategoryTagId = findRow.hazardCategoryTagId;
    data.hazardCategoryTagName = findRow.hazardCategoryTagName;
    data.hazardCode = findRow.hazardCode;
    data.riskLevel = findRow.riskLevel;
    data.riskControlRunawayShow = findRow.riskControlRunawayShow;
    data.stockRoom = findRow.stockRoom;
    data.taskPostId = findRow.taskPostId;
    data.teamGroup = findRow.teamGroup;
    data.workShop = findRow.workShop;
    data.postIds = findRow.postIds;
    data.postNames = findRow.postNames;
    data.company = findRow.company;
  }

  private submitForm() {
    const formComponent: any = this.$refs['formRef'];
    formComponent.validate((valid: any) => {
      if (valid) {
        if (this.technologyMeasureHazardList.length > 0) {
          const lastRowData: any = this.technologyMeasureHazardList[this.technologyMeasureHazardList.length - 1];
          if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
            this.$message.warning('请将工程技术措施数据填写完整！');
            return;
          }
        }
        if (this.controlMeasuresHazardList.length > 0) {
          const lastRowData: any = this.controlMeasuresHazardList[this.controlMeasuresHazardList.length - 1];
          if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
            this.$message.warning('请将安全管理措施数据填写完整！');
            return;
          }
        }
        if (this.individualProtectShowHazardList.length > 0) {
          const lastRowData: any = this.individualProtectShowHazardList[this.individualProtectShowHazardList.length - 1];
          if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
            this.$message.warning('请将个体防护措施数据填写完整！');
            return;
          }
        }
        if (this.trainingAndEducationalMeasuresHazardList.length > 0) {
          const lastRowData: any = this.trainingAndEducationalMeasuresHazardList[this.trainingAndEducationalMeasuresHazardList.length - 1];
          if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
            this.$message.warning('请将培训教育措施数据填写完整！');
            return;
          }
        }
        if (this.emergencyTreatmentMeasuresHazardList.length > 0) {
          const lastRowData: any = this.emergencyTreatmentMeasuresHazardList[this.emergencyTreatmentMeasuresHazardList.length - 1];
          if (!lastRowData.riskDescription || !lastRowData.hazardControlMeasure || !lastRowData.riskControlRunawayShow) {
            this.$message.warning('请将应急处置措施数据填写完整！');
            return;
          }
        }
        if (this.rowData.type === 'edit') {
          // 编辑页面
          this.modifyRiskControlInventory();
        } else {
          this.addRiskControlInventory();
          // 新增页面
        }
      }
    });
  }

  // 新增
  private addRiskControlInventory() {
    let postName: any = '';
    if (this.formData.postId) {
      postName = this.postIdList.find((item: any) => item.id === this.formData.postId).name;
    }
    let deviceName: any = '';
    if (this.formData.deviceId) {
      deviceName = this.deviceList.find((item: any) => item.deviceGuid === this.formData.deviceId).deviceName;
    }
    this.submitLoading = true;
    doublePrevention
      .addRiskControlInventory({
        ...this.formData,
        postName,
        deviceName,
        technologyMeasureHazardList: this.technologyMeasureHazardList,
        controlMeasuresHazardList: this.controlMeasuresHazardList,
        individualProtectShowHazardList: this.individualProtectShowHazardList,
        trainingAndEducationalMeasuresHazardList: this.trainingAndEducationalMeasuresHazardList,
        emergencyTreatmentMeasuresHazardList: this.emergencyTreatmentMeasuresHazardList,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功添加了一条数据！');
          this.submitLoading = false;
          this.backClose();
        } else {
          this.$message.warning(res.msg);
          this.submitLoading = false;
        }
      });
  }

  // 编辑
  private modifyRiskControlInventory() {
    let postName: any = '';
    if (this.formData.postId) {
      postName = this.postIdList.find((item: any) => item.id === this.formData.postId).name;
    }
    let deviceName: any = '';
    if (this.formData.deviceId) {
      deviceName = this.deviceList.find((item: any) => item.deviceGuid === this.formData.deviceId).deviceName;
    }
    this.submitLoading = true;
    doublePrevention
      .modifyRiskControlInventory({
        ...this.formData,
        postName,
        deviceName,
        technologyMeasureHazardList: this.technologyMeasureHazardList,
        controlMeasuresHazardList: this.controlMeasuresHazardList,
        individualProtectShowHazardList: this.individualProtectShowHazardList,
        trainingAndEducationalMeasuresHazardList: this.trainingAndEducationalMeasuresHazardList,
        emergencyTreatmentMeasuresHazardList: this.emergencyTreatmentMeasuresHazardList,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功编辑了该条数据！');
          this.submitLoading = false;
          this.backClose();
        } else {
          this.$message.warning(res.msg);
          this.submitLoading = false;
        }
      });
  }

  // 详情
  private getRiskControlInventoryDetail() {
    doublePrevention.getRiskControlInventoryDetail(this.rowData.id).then((res: any) => {
      if (res.code === '200') {
        this.formData.riskPointId = res.data.riskPointId;
        this.formData.dangerSourceId = res.data.dangerSourceId;
        this.formData.riskTypeTagName = res.data.riskTypeTagName;
        this.formData.energyCharacteristic = res.data.energyCharacteristic;
        this.formData.controlHierarchy = res.data.controlHierarchy;
        this.formData.riskDescription = res.data.riskDescription;
        this.formData.hurtDegree = res.data.hurtDegree;
        this.formData.taskRiskPoint = res.data.taskRiskPoint;
        this.formData.possibility = res.data.possibility;
        this.formData.seriousness = res.data.seriousness;
        this.formData.riskDegree = res.data.riskDegree;
        this.formData.riskLevel = res.data.riskLevel;
        this.formData.postId = res.data.postId;
        this.formData.measuresForTrainingEducation = res.data.measuresForTrainingEducation;
        this.formData.emergencyMeasures = res.data.emergencyMeasures;
        this.formData.remark = res.data.remark;
        this.formData.id = res.data.id;
        this.areaId = res.data.areaId;
        this.formData.riskEventDescription = res.data.riskEventDescription;
        this.formData.consequenceDescription = res.data.consequenceDescription;

        this.technologyMeasureHazardList = res.data.technologyMeasureHazardList;
        this.controlMeasuresHazardList = res.data.controlMeasuresHazardList;
        this.individualProtectShowHazardList = res.data.individualProtectShowHazardList;
        this.trainingAndEducationalMeasuresHazardList = res.data.trainingAndEducationalMeasuresHazardList;
        this.emergencyTreatmentMeasuresHazardList = res.data.emergencyTreatmentMeasuresHazardList;

        doublePrevention.getRiskAll({ areaId: res.data.areaId }).then((res: any) => {
          if (res.code === '200') {
            this.riskPointAndDangerData = res.data;
            this.riskPointList = res.data.filter((item: any) => item.type === '风险点');
            this.dangerSourceIdList = res.data.filter((item: any) => item.type === '危险源' && item.pid === this.formData.riskPointId);
          } else {
            this.$message.warning('获取风险点和危险源的数据失败！');
          }
        });
        this.getRiskDescriptionListData({
          riskPointId: this.formData.riskPointId,
          dangerSourceId: this.formData.dangerSourceId,
        });
        /*this.$nextTick(() => {
          if (res.data.areaId) {
            const pathLabels: any = (this.$refs.elCascaderRef as any).getCheckedNodes()[0].pathLabels.join();
            const getNode: any = document.querySelector('.el-cascader_width .el-input .el-input__inner');
            getNode.style.width = pathLabels.length * 14 + 40 + 'px';
          }
        })*/
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private backClose() {
    this.$emit('closePage');
  }
}
